module.exports = __webpack_public_path__ + "static/media/ofertas_pisos.0ea98041.jpg";